import { render } from "./ShopIndexView.vue?vue&type=template&id=8eb5a9b0&scoped=true"
import script from "./ShopIndexView.vue?vue&type=script&lang=js"
export * from "./ShopIndexView.vue?vue&type=script&lang=js"

import "./ShopIndexView.vue?vue&type=style&index=0&id=8eb5a9b0&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eb5a9b0"]])

export default __exports__